import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  Label,
  Spinner,
  FormFeedback,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_Newbook,
  API_Partner_Newbook,
  API_Flexkeeping,
  API_Partner_Flexkeeping,
} from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
export default function FlexkeepingIntegration({ visible, toggle, id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [property, setProperty] = useState([]);
  const [selectedproperty, setSeletedProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    name: 'Flexkeeping',
    channel: 'Flexkeeping',
    level: 'Group',
    properties: [],
    apiKey: ''
  });

  const [facilities, setFacilities] = useState([]);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [debouncedApiKey, setDebouncedApiKey] = useState(inputData.apiKey);
  const [error, setError] = useState({
    statusCode: null,
    message: null
  });


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedApiKey(inputData.apiKey);
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler);
    };
  }, [inputData.apiKey]);

  useEffect(() => {

    if (id !== undefined) {
      setIsLoading(true);
      AxiosAPI({
        method: 'get',
        url: `${API_Flexkeeping}/${id}/flexkeeping?groupId=${getGroupID()}`,
      })
        .then((res) => {
          const data = res.data;
          let filterList = [];
          if (data.properties && Array.isArray(data.properties)) {
            filterList = data.properties
              .filter((elem) => elem !== undefined && elem !== null)
              .map(String);
          }
          let obj = {
            groupId: data.groupId,
            name: data.name || '',
            channel: data.channel || 'Flexkeeping',
            level: data.level || 'Group',
            properties: filterList,
            apiKey: data.flexkeepingIntegration.apiKey || ''
          };

          setInputData(obj);
          setSeletedProperty(filterList);
          fetchFacilities(data.flexkeepingIntegration.apiKey).then((res) => {
            if (res.status === 200 || res.status === 201) {
              setSelectedFacilities(res?.data?.filter(f => data.flexkeepingIntegration.facilities?.includes(f.id)).map(f => ({ label: `${f.title} - ${f.destination} (${f.id})`, value: f.id })) || []);
            } else {
              setSelectedFacilities([]);
            }
          })
        })
        .catch((err) => console.error(err))
        .finally(() => setIsLoading(false));
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        let list = [];
        if (Array.isArray(res.data)) {
          list = res.data;
        } else if (Array.isArray(res.data?.data)) {
          list = res.data.data;
        } else if (Array.isArray(res.data?.properties)) {
          list = res.data.properties;
        }
        setProperty(list);
      })
      .catch((err) => console.error(err));
  }, [id]);

  const handleSave = () => {
    if (!inputData.apiKey || !selectedFacilities?.length || error.message) return;
    let body = inputData;
    body.facilities = selectedFacilities?.map(f => f.value) || [];
    if (id !== undefined) {
      body.groupId = getGroupID();
      AxiosAPI({
        method: 'put',
        url: `${API_Flexkeeping}/${id}/flexkeeping`,
        data: body,
      }).then(() => {
        toggle();
        setTimeout(() => {
          window.location.reload();
        }, 300);
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: `${API_Flexkeeping}/flexkeeping`,
        data: body,
      }).then((res) => {
        if (
          res.data?.HttpStatusCode === 400 &&
          res.data?.Messages?.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        setTimeout(() => {
          window.location.reload();
        }, 300);
      });
    }
  };

  const handleCheckChange = (e) => {
    const value = String(e.target.value);
    let updatedList = [];
    if (selectedproperty.includes(value)) {
      updatedList = selectedproperty.filter((item) => item !== value);
    } else {
      updatedList = [...selectedproperty, value];
    }
    setSeletedProperty(updatedList);
    setInputData({ ...inputData, properties: updatedList });
  };

  const handleChange = (e) => {
    setInputData({
      ...inputData,
      [e.target.name]: e.target.value,
    });
  };

  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  // Fetch facilities from API (POST method)
  const fetchFacilities = async (debouncedApiKey) => {
    try {
      setIsLoading(true);
      const res = await AxiosAPI({
        method: 'post',
        url: `${API_Partner_Flexkeeping}/all-facilities`,
        headers: {
          'Content-Type': 'application/json',
          'api-Key': debouncedApiKey,
          'User-Agent': 'integrator-a'
        },
        data: {}
      });

      if (res.status === 200 || res.status === 201) {
        setError({ statusCode: null, message: null });
        if (Array.isArray(res.data)) {
          setFacilities(res.data);
        } else {
          setFacilities([]);
        }

        return res
      }
    } catch (err) {
      setFacilities([]);
      setError({ statusCode: err.response?.status || null, message: err?.response?.data?.message || null });
      return err;
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (debouncedApiKey) {
      fetchFacilities(debouncedApiKey);
    }

  }, [debouncedApiKey]);


  const handleFacilitiesChange = (selectedOptions) => {
    setSelectedFacilities(selectedOptions)
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="md">
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Add Integration</h6>
                <Separator className="mb-3" />

                <FormGroup className="mb-2 text-left">
                  <Label>Integration Name</Label>
                  <Input
                    name="name"
                    defaultValue={inputData.name}
                    onChange={handleChange}
                    // disabled={true}
                    readOnly={true}
                  />
                </FormGroup>
                <FormGroup className="mb-2 text-left">
                  <Label>API Key</Label>
                  <Input
                    name="apiKey"
                    defaultValue={inputData.apiKey}
                    onChange={handleChange}
                  />
                  {error.message && (
                    <div className="mt-1" style={{ color: 'red' }}>
                      {error.message}
                    </div>
                  )}
                </FormGroup>

                <FormGroup className="mb-2 text-left">
                  <Label>
                    Select Facilities
                  </Label>
                  <Select
                    components={{ Input: CustomSelectInput }}
                    isMulti
                    options={facilities?.map(f => ({
                      value: f.id,
                      label: `${f.title} - ${f.destination} (${f.id})`
                    }))}
                    className="react-select"
                    classNamePrefix="react-select"
                    value={selectedFacilities}
                    onChange={handleFacilitiesChange}
                    isLoading={isLoading}
                  />
                </FormGroup>

                <FormGroup>
                  <div className="integration-property">
                    {property.map((p, index) => {
                      return (
                        <CustomInput
                          key={p.id}
                          type="checkbox"
                          id={index}
                          label={p.name}
                          value={String(p.id)}
                          onChange={handleCheckChange}
                          checked={inputData.properties.includes(String(p.id))}
                        />
                      );
                    })}
                  </div>
                </FormGroup>

                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      {' '}
                      Create New Integration{' '}
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      {' '}
                      Update Integration{' '}
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    {' '}
                    Cancel{' '}
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>

      <Validation open={open} messages={msg} toggle={() => setOpen(!open)} />
    </Fragment>
  );
}
